import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";
import { Article } from "@/types/article";

interface ArticleCardProps {
  article: Article;
  index: number;
  iconMap: Record<string, any>;
}

export const ArticleCard = ({ article, index, iconMap }: ArticleCardProps) => {
  const Icon = iconMap[article.category as keyof typeof iconMap] || AlertCircle;
  const slug = article.title
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');

  return (
    <Link to={`/${slug}`} className="w-full max-w-md">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: index * 0.1 }}
        viewport={{ once: true }}
        className="p-6 bg-white rounded-2xl shadow-sm hover:shadow-md transition-all duration-200 group cursor-pointer w-full h-full flex flex-col"
      >
        <div className="mb-4 text-spirit-600 flex justify-center">
          <Icon className="w-8 h-8 group-hover:scale-110 transition-transform duration-200" />
        </div>
        <h3 className="text-xl font-medium text-gray-900 mb-2">
          {article.title}
        </h3>
        <p className="text-gray-600 mb-4 flex-grow">
          {article.summary}
        </p>
        <div className="mt-auto">
          <Button
            variant="secondary"
            className="w-full bg-spirit-100 hover:bg-spirit-200 text-spirit-700"
          >
            Read More
          </Button>
        </div>
      </motion.div>
    </Link>
  );
};